import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'
import { PurposeTag } from 'frontend/purpose-tags'
import { markRaw } from 'vue'

export const PurposeTagDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'name',
    'label',
    'tag_scope',
    'event_id',
    'description',
    'background_color',
    'border_color',
    'font_color',
    'created_at',
    'updated_at',
  ],
  subscriptions: {
    items: 'PurposeTagsChannel',
  },
  defaultColumns: [
    'name',
    'label',
    'tagScope',
    'description',
    'createdDatetime',
    'updatedDatetime',
  ],
  columnConfig: {
    name: {
      label: 'Name',
      header: {
        sort: 'name',
      },
      cell: {
        kind: 'simple',
        path: 'name',
      },
    },
    label: {
      label: 'Label',
      header: {
        sort: 'name',
      },
      cell: {
        kind: 'component',
        component: markRaw(PurposeTag),
        componentProps: purposeTag => ({ purposeTag }),
      },
    },
    tagScope: {
      label: 'Scope',
      header: {
        sort: 'tag_scope',
      },
      cell: {
        kind: 'component',
        component: 'erebus-label',
        componentProps: purposeTag => {
          if (purposeTag.tagScope === 'organization') {
            return {
              item: {
                name: 'Organization',
                backgroundColor: '#343ebe',
                borderColor: '#343ebe',
                fontColor: '#FFFFFF',
              },
            }
          }
          return {
            item: {
              name: 'Event',
              backgroundColor: '#11780e',
              borderColor: '#11780e',
              fontColor: '#FFFFFF',
            },
          }
        },
      },
    },
    description: {
      label: 'Description',
      header: {
        sort: 'description',
      },
      cell: {
        kind: 'simple',
        path: 'description',
      },
    },
    createdDatetime: {
      label: 'Created Datetime',
      header: {
        sort: 'created_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.createdAt }),
      },
    },
    createdDate: {
      label: 'Created Date',
      header: {
        sort: 'created_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.createdAt, format: 'dateOnly' }),
      },
    },
    createdTime: {
      label: 'Created Time',
      header: {
        sort: 'created_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.createdAt, format: 'timeOnly' }),
      },
    },
    updatedDatetime: {
      label: 'Updated Datetime',
      header: {
        sort: 'updated_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.updatedAt }),
      },
    },
    updatedDate: {
      label: 'Updated Date',
      header: {
        sort: 'updated_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.updatedAt, format: 'dateOnly' }),
      },
    },
    updatedTime: {
      label: 'Updated Time',
      header: {
        sort: 'updated_at',
      },
      cell: {
        kind: 'component',
        component: 'formatted-time',
        componentProps: purposeTag => ({ t: purposeTag.updatedAt, format: 'timeOnly' }),
      },
    },
  },
}
